module.exports = __webpack_public_path__ + "static/media/paralax3.08d95773.jpg";